import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { observer } from "mobx-react";
import { graphql, compose } from "react-apollo";
import { queryGetCustomerJourney } from "Apollo";
import moment from "moment";
import { Scrollbars } from "react-custom-scrollbars";
import CaseJourney from "./chat/CaseJourney";
import Avatar from "antd";

export default compose(
  graphql(queryGetCustomerJourney, {
    options: ({ selectedId }) => ({ variables: { id: selectedId } })
  })
)(
  observer(
    class Timeline extends Component {
      static propTypes = {
        selectedId: PropTypes.number
      };
      state = {
        id: 0,
        nameFrom: "",
        displayPictureFrom: "",
        nameTo: "",
        displayPictureTo: "",
        actionType: "",
        operationType: "",
        content: "",
        dateBegin: "",
        dateEnd: "",
        isMonthActive: false,
        monthAfter: "",
        isFirst: false
      };
      states = { loadingPagination: false };

      preprocessData = () => {
        const { data: { getCustomerJourney: listJourney } } = this.props;
        const rows = [];

        if (listJourney) {
          const len = listJourney.edges.length;
          const row = listJourney.edges;
          for (let i = 0; i < len; i++) {
            rows.push({
              id: row[i].node.id,
              caseId: row[i].node.case !== null ? row[i].node.case.id : null,
              case: row[i].node.case !== null ? row[i].node.case : null,
              nameFrom: row[i].node.actionFrom.name,
              displayPictureFrom: row[i].node.actionFrom.displayPicture,
              nameTo: row[i].node.actionTo.name,
              displayPictureTo: row[i].node.actionTo.displayPicture,
              actionType: row[i].node.actionTypeCustomerJourney,
              operationType: row[i].node.operationTypeCustomerJourney,
              content: row[i].node.content,
              dateBegin: row[i].node.dateCreated,
              dateEnd: row[i].node.dateEnd,
              isFirst: i === 0 ? true : false,
              isMonthActive:
                moment(row[i].node.dateCreated).format("M") !==
                moment(row[i + 1 === len ? i : i + 1].node.dateCreated).format(
                  "M"
                )
                  ? true
                  : false,
              monthAfter: moment(
                row[i + 1 === len ? i : i + 1].node.dateCreated
              ).format("MMMM")
            });
          }
        }

        return rows;
      };

      render() {
        const { selectedId } = this.props;
        const dataList = this.preprocessData();
        const renderLists = dataList.map((row, index) => (
          <Event key={"journey" + row.id}>
            {row.isFirst && <SpanMonthFirst>{row.monthAfter}</SpanMonthFirst>}
            <Icon />
            {row.actionType === "STREAM" ? (
              <Content>
                <CaseJourney
                  id={row.id}
                  caseId={row.caseId}
                  case={row.case}
                  image={row.displayPictureFrom}
                  nameFrom={row.nameFrom}
                  content={row.content}
                  dateBegin={moment(row.dateBegin).format("DD/MM/YY")}
                  dateEnd={moment(row.dateEnd).format("DD/MM/YY")}
                />
                {row.isMonthActive && <SpanMonth>{row.monthAfter}</SpanMonth>}
              </Content>
            ) : (
              <Content>
                <SpanDate>
                  {moment(row.dateBegin).format("DD MMMM YYYY")}
                </SpanDate>
                <SpanContent>
                  {row.nameFrom} {row.operationType.toLowerCase()} {""}
                  {row.actionType.toLowerCase()} "{row.content}"
                </SpanContent>
                {row.isMonthActive && <SpanMonth>{row.monthAfter}</SpanMonth>}
              </Content>
            )}
          </Event>
        ));

        return (
          <Scrollbars
            ref={ref => (this.scroller = ref)}
            onScrollFrame={this.onScrollFrame}
          >
            <Wrapper>
              <WrapperBefore />
              {renderLists}
              <WrapperAfter />
            </Wrapper>
          </Scrollbars>
        );
      }
      onScrollFrame = event => {
        // detect if on bottom scroll
        if (event.top > 0.8) {
          this.onEndReached();
        }
      };

      onEndReached = async () => {
        const { data: { fetchMore, getCustomerJourney } } = this.props;
        if (getCustomerJourney && getCustomerJourney.edges.length > 0) {
          if (!this.states.loadingPagination) {
            this.states.loadingPagination = true;
            const length = getCustomerJourney.edges.length;
            const cursor = getCustomerJourney.edges[length - 1].cursor;
            await fetchMore({
              variables: {
                after: cursor
              },
              updateQuery: (prevResult, { fetchMoreResult }) => {
                if (!fetchMoreResult) return prevResult;
                const result = Object.assign(
                  {},
                  prevResult.getCustomerListPagination,
                  {
                    edges: [
                      ...prevResult.getCustomerJourney.edges,
                      ...fetchMoreResult.getCustomerJourney.edges
                    ]
                  }
                );
                return { getCustomerJourney: result };
              }
            });
            this.states.loadingPagination = false;
          }
        }
      };
    }
  )
);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 20px 0;
`;

const WrapperBefore = styled.div`
  content: "";
  position: absolute;
  top: 0;
  left: 18px;
  height: 100%;
  width: 2px;
  background: #e1dfde;
`;
const WrapperAfter = styled.div`
  content: "";
  display: table;
  clear: both;
`;

const Event = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
`;

const Icon = styled.span`
  width: 1px;
  height: 1px;
  border-radius: 100%;
  background: #e1dfde;
  padding: 5px;
  z-index: 1;
  margin: 14px;
`;

const Content = styled.div`
  padding: 10px;
`;

const SpanDate = styled.div`
  color: #b9b9b9;
`;
const SpanContent = styled.div`
  margin-top: 5px;
`;

const SpanMonth = styled.div`
  background: #e1dfde;
  padding: 2px 20px;
  border-radius: 10px;
  width: 100px;
  margin-top: 30px;
  margin-bottom: -10px;
  margin-left: -40px;
`;

const SpanMonthFirst = styled.div`
  background: #e1dfde;
  padding: 2px 20px;
  border-radius: 10px;
  width: 100px;
  position: absolute;
  top: 0;
  left: 7px;
`;



// WEBPACK FOOTER //
// ./src/module-customer-journey/detail/Timeline.js